<template>
  <main-layout>
    <div slot="sidebar" class="site-box">
      <category-list v-bind:category="this.$store.state.sceneList" v-bind:groupId="groupId"></category-list>
    </div>
    <div slot="content" class="site-box">
        <h2 class="title">{{title}}</h2>
        <div class="markdown-container">
          <vue-markdown :source="markdown"></vue-markdown>
        </div>
        <scroll-nav v-bind:scrollList="scrollList"></scroll-nav>
    </div>
  </main-layout>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  @import '../../../../node_modules/prismjs/themes/prism.css';
  .markdown-container{
    width: 700px;
  }
</style>
<script>
  /* eslint-disable */
  import VueMarkdown from 'vue-markdown';
  import 'prismjs';
  import ScrollNav from '../components/ScrollNav';
  import CategoryList from '../components/CategoryList';
  import MainLayout from '../../../layouts/MainLayout';

  export default {
    components: {
      MainLayout,
      VueMarkdown,
      ScrollNav,
      CategoryList,
    },
    data() {
      return {
        breadcrumbList: [
          {
            to: '/',
            text: '使用文档',
          },
          {
            to: '/rule/',
            text: '平台规则',
          },
        ],
        title:'111',
        markdown: '',
        groupId: '',
        itemId: '',
        scrollList:[],
      };
    },
    mounted() {
      const params = this.$route.params;
      const groupId = params.category_id;
      const itemId = params.post_id;
      this.groupId = groupId;
      this.itemId = itemId;
      this.fetchMarkdown();
    },
    updated() {
      //this.initScroll();
    },
    methods: {
      fetchMarkdown() {
        const params = this.$route.params;
        const groupId = params.category_id;
        const itemId = params.post_id;
        this.$http.get(`${process.env.API_URL}/${this.$route.params.language}/guide/article/1/${itemId}`).then((res) => {
          if(res.body.code == 200000){
            this.markdown = res.body.data.text;
            this.title = res.body.data.title;
            this.$nextTick(()=>{
              this.initScroll();
              Prism.highlightAll()
            })
          }else{
            this.markdown = '查询失败';
          }
        }, (res) => {
          this.markdown = 'error';
          this.title = 'error';
        });
      },
      initScroll(e){
        if(this.$route.params.category_id.length > 0){
          var list = [];
          var links = document.querySelectorAll('.markdown-container h4,.markdown-container h5');
          links.forEach((item)=>{
            var obj = {
              ele: item,
              title : item.innerText,
              type: item.tagName,
              offsetTop:item.offsetTop
            }
            list.push(obj);
          })
          this.scrollList = list;
        }
      },
    },
    watch: {
      '$route':'fetchMarkdown'
    },
  };
</script>



// WEBPACK FOOTER //
// Scene.vue?2a65691c